/**
 * Copy de apresentação dos 12 segmentos canônicos do motor RFM.
 *
 * A decisão de segmento é SEMPRE do backend (`data.segmentoRfm` do POST
 * /api/v4/rfm/:idfornecedor/simular ou GET /api/v4/rfm/segmentos). Este mapa
 * apenas descreve, por nome canônico, o texto exibido na tela.
 */

export const SEGMENTOS_RFM_CANONICOS = [
  "Campeões",
  "Não perder",
  "Em risco",
  "VIPs",
  "Novos clientes",
  "Promissores",
  "Potenciais",
  "Precisam de atenção",
  "Quase perdidos",
  "Hibernando",
  "Perdidos",
  "Outros"
];

const COPY_POR_SEGMENTO = {
  Campeões: {
    descricao:
      "Compraram recentemente, com alta frequência e alto valor faturado no período.",
    acao:
      "Reconheça e recompense: pré-lançamentos, benefícios exclusivos e indicação."
  },
  "Não perder": {
    descricao:
      "Excelente histórico de frequência e valor, porém sem comprar há bastante tempo.",
    acao: "Contato comercial prioritário, com condição especial de retorno."
  },
  "Em risco": {
    descricao:
      "Boa frequência e bom valor no histórico, mas a última compra está distante.",
    acao:
      "Campanha de reativação personalizada e contato do vendedor responsável."
  },
  VIPs: {
    descricao:
      "Compram com regularidade e concentram o maior faturamento da base.",
    acao: "Atendimento dedicado, condições diferenciadas e ações de retenção."
  },
  "Novos clientes": {
    descricao:
      "Compraram há pouco tempo e ainda têm poucos pedidos no período.",
    acao: "Onboarding, incentivo ao segundo pedido e acompanhamento próximo."
  },
  Promissores: {
    descricao:
      "Compra recente, poucos pedidos e valor faturado ainda moderado.",
    acao:
      "Ofertas de recorrência e recomendação de mix para criar hábito de compra."
  },
  Potenciais: {
    descricao:
      "Boa recência e boa frequência, mas o valor ainda está abaixo do topo da base.",
    acao: "Cross-selling e upsell para elevar o tíquete médio."
  },
  "Precisam de atenção": {
    descricao: "Métricas medianas nas três dimensões, sem destaque nem alerta.",
    acao: "Ofertas segmentadas e lembretes de reposição de estoque."
  },
  "Quase perdidos": {
    descricao:
      "Recência baixa, com frequência e valor apenas intermediários no período.",
    acao: "Campanha de reconquista com incentivo direto e prazo definido."
  },
  Hibernando: {
    descricao: "Baixa recência, baixa frequência e baixo valor faturado.",
    acao: "Ações de baixo custo: e-mail de reengajamento e pesquisa de motivo."
  },
  Perdidos: {
    descricao:
      "Sem comprar há muito tempo e com o menor histórico de pedidos da base.",
    acao: "Campanhas esporádicas de reconquista e análise de churn."
  },
  Outros: {
    descricao:
      "Combinação de notas que não se enquadra nas regras dos demais grupos.",
    acao: "Avalie individualmente antes de incluir em campanhas."
  }
};

const COPY_PADRAO = {
  descricao: "Grupo retornado pelo motor RFM.",
  acao: ""
};

/** Copy de um segmento pelo nome canônico devolvido pela API. */
export function copySegmento(nome) {
  return { nome, ...(COPY_POR_SEGMENTO[nome] || COPY_PADRAO) };
}

/** Lista para o guia "Como funcionam os Grupos?". */
export function guiaSegmentos(nomes) {
  const lista =
    Array.isArray(nomes) && nomes.length ? nomes : SEGMENTOS_RFM_CANONICOS;
  return lista.map(copySegmento);
}
